<ng-container *ngIf="actions$ | async as operation" [xOperation]="operation">
  <ng-container [ngTemplateOutlet]="mode === 'compact' ? COMPACT : EXPAND"></ng-container>
  <x-loader *ngIf="operation.status === 'loading'"></x-loader>
  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>

<!--compact-->
<ng-template #COMPACT>
  <div class="item compact" *ngIf="item">
    <div class="media">
      <a [routerLink]="item.productId | productUrl">
        <x-media-thumbnail [url]="item.media.url" [width]="100" [height]="100"></x-media-thumbnail>
      </a>
    </div>
    <div class="content">
      <header class="mat-body-2" [innerText]="item | orderItemName"></header>
      <div class="item-price">
        <div class="subtotal mat-display-2">
          {{ item.unitPrice | money: currency }}
        </div>
        <x-availability
          [availabilityView]="item.availabilityView"
          [availableRegions]="item.availableRegions"
          [availableQuantity]="item.availability?.maxAvailableQuantity"
        ></x-availability>
      </div>
      <div class="content-footer">
        <ng-container *ngTemplateOutlet="CONTROLS"></ng-container>
        <ng-container *ngTemplateOutlet="TOTAL"></ng-container>
      </div>
    </div>
    <div class="action" *ngIf="item.source === orderItemSource.Order">
      <button mat-icon-button (click)="removeItem(item.variantId)">
        <fa-icon icon="trash" xIconSize="large"></fa-icon>
      </button>
    </div>
  </div>
</ng-template>

<!--expanded-->
<ng-template #EXPAND>
  <div class="item expand" *ngIf="item">
    <div class="product">
      <div class="media">
        <x-media-thumbnail [url]="item.media.url" [width]="80" [height]="80"></x-media-thumbnail>
      </div>

      <div class="title mat-display-2">
        {{ item | orderItemName }}
        <div *ngFor="let adjustment of item.adjustments" class="order-adjustment">
          <ng-container *ngIf="adjustment.amount !== 0">
            {{ adjustment.label }}
          </ng-container>
        </div>
        <x-availability
          [availabilityView]="item.availabilityView"
          [availableRegions]="item.availableRegions"
          [availableQuantity]="item.availability?.maxAvailableQuantity"
        ></x-availability>
      </div>
    </div>

    <div class="price">
      {{ item.unitPrice | money: currency }}
    </div>

    <div class="quantity">
      <ng-container *ngTemplateOutlet="CONTROLS"></ng-container>
    </div>

    <div class="total">
      <ng-container *ngTemplateOutlet="TOTAL"></ng-container>
    </div>

    <div class="action justify-content-center" *ngIf="item.source === orderItemSource.Order">
      <button mat-icon-button (click)="removeItem(item.variantId)">
        <fa-icon icon="trash" xIconSize="large"></fa-icon>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #TOTAL>
  <span class="unit-total" [class.mat-subtotal]="mode === 'compact'">
    @if (item.total === 0) {
      <span class="px-2 py-1 rounded-pill text-center text-uppercase promo-price-free">Free</span>
    } @else if (item.unitsTotal > item.total) {
      <s>{{ item.unitsTotal | money: currency }}</s>
      {{ item.total | money: currency }}
    } @else {
      {{ item.total | money: currency }}
    }
  </span>
</ng-template>

<ng-template #CONTROLS>
  <div class="quantity-only" *ngIf="disableQuantityControl; else SHOW_CONTROLS">
    {{ item.quantity }}
  </div>

  <ng-template #SHOW_CONTROLS>
    <x-quantity-control
      class="quantity"
      size="small"
      [itemQuantity]="item.quantity"
      (quantityUpdated)="updated($event, item)"
      [availableQuantity]="item.availability?.maxAvailableQuantity"
    ></x-quantity-control>
  </ng-template>
</ng-template>
